import { getClientType } from '../../../tools/session/clientSession';
import { fetchClientJSON, fetchClientText } from '../../../tools/uploads/uploadsClient';
import { parseCsv } from '../../../tools/csv/parseCsv';
import { updateTraffixData } from '../../../components/common/traffixLoadingData';
import { httpPost } from '../../../tools/http/httpClient';

export const fetchMetricsData = async (options = {}) => {
  const clientType = getClientType();
  try {
    const csvText = await fetchClientText(clientType, 'metrics.csv', options);
    const data = parseCsv(csvText);
    updateTraffixData(data);
    return data;
  } catch (error) {
    console.error('Error loading metrics.csv, falling back to metrics.json:', error);
    const data = await fetchClientJSON(clientType, 'metrics.json', options);
    updateTraffixData(data);
    return data;
  }
};

export const fetchTrafficCSV = (options) => fetchMetricsData(options);
export const fetchTrafficZoneData = (options) => fetchMetricsData(options);

export const fetchNetworkOffsetData = async () => {
  const clientType = getClientType();
  try {
    const geojson = await fetchClientJSON(clientType, 'network_offset.geojson');
    if (geojson.features) {
      geojson.features = geojson.features.map((feature) => ({
        ...feature,
        properties: {
          ...feature.properties,
          hash: feature.properties.UnifiedID,
          StreetName: feature.properties.StreetName,
          SpeedLimit: feature.properties.SpeedLimit,
          Length: feature.properties.Length_sum,
          FRC: feature.properties.FRC,
          'Segment Id': feature.properties.UnifiedID,
        },
      }));
      updateTraffixData(geojson.features.map((f) => f.properties));
    }
    return geojson;
  } catch (error) {
    console.error('Error loading network_offset.geojson:', error);
    return fetchClientJSON(clientType, 'archi_zona.geojson');
  }
};

export const fetchMapGeoJSON = () => fetchNetworkOffsetData();
export const fetchArchiZonaGeoJSON = () => fetchNetworkOffsetData();
export const fetchAnimatedVehicles = () => fetchClientJSON(getClientType(), 'animated_vehicles.geojson');
export const fetchTripsData = () => fetchClientJSON(getClientType(), 'trips_deckgl.json');
export const fetchPointCloud3D = () => fetchClientJSON(getClientType(), 'NuvolaPunti3d.json');
export const fetchBuildingsData = async () => {
  const clientType = getClientType();
  try {
    return await fetchClientJSON(clientType, 'buildings.geojson');
  } catch (_) {
    return fetchClientJSON(clientType, 'buildings_genova.json');
  }
};

export function queryTrafficAnalysis(query) {
  return httpPost('/api/traffic-analysis/query', {
    query,
    data_source: `${getClientType()}.csv`,
    temperature: 0,
  }, { loadingKey: 'traffic-analysis' });
}
